import React from 'react';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import { required } from '../../../../../antd/form/FormValidation.js';
import FormTextEditor from '../../../../../antd/form/FormTextEditor/FormTextEditor.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect.jsx';

const FoWorkshopForm = ({ onSubmit, initials, teachers }) => {
  const { t } = useTranslation();

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Form onFinish={handleSubmit} initialValues={initials}>
      <FormTextField label={t('Názov')} name={'name'} rules={[required(t)]} />
      <FormSelect
        label={t('Lektor')}
        name={'lecturer_id'}
        options={teachers}
        placeholder={t('Vyhľadať lektora')}
        rules={[required(t)]}
      />
      <FormTextEditor label={t('Popis')} name={'description'} />
      <FormButtonsContainer>
        <FormButton submitOnClick={true}>{t('Uložiť')}</FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default FoWorkshopForm;
